import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
  LOCALE_ID,
  DEFAULT_CURRENCY_CODE,
  provideAppInitializer,
  inject,
  isDevMode
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

import { NgbDateAdapter,NgbDateParserFormatter,NgbInputDatepickerConfig,NgbModalConfig,NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { includeBearerTokenInterceptor } from 'keycloak-angular';

import { routes } from './app.routes';
import { provideKeycloakAngular } from './utilities/configs/keycloak.config';
import { errorInterceptor } from './utilities/interceptors/error.interceptor';
import { DateParserFormatterService } from './utilities/services/datepicker/date-parser-formatter.service';
import { DateAdapterService } from './utilities/services/datepicker/date-adapter.service';
import { tenantInterceptor } from './utilities/interceptors/tenant-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(NgbModule),
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideKeycloakAngular(),
    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor, errorInterceptor, tenantInterceptor]),
      ...(isDevMode() ? [withXhr()] : [])
    ),
    { provide: NgbDateAdapter, useClass: DateAdapterService },
    { provide: NgbDateParserFormatter, useClass: DateParserFormatterService },
    provideAppInitializer(() => {
      const configDatePicker = inject(NgbInputDatepickerConfig);
      configDatePicker.container = 'body';

      const configModal = inject(NgbModalConfig);
      configModal.backdrop = 'static';
    })
  ],
};
